module.exports = __webpack_public_path__ + "img/icon-esim-detail-copy-light.d2f6178.svg";